/* Project Import will be here */
import { getPrincipalsApi, getProfilePrincipalsApi } from "../services/common";
import { getAnyTokenFromState } from "services/index";
import { getErrorObject, normalize } from "../utilities/utils";
/* Project Import will be here */

export const types = {
  PRINCIPAL_REQUEST: "principle/PRINCIPAL_REQUEST",
  PRINCIPAL_SUCCESS: "principle/PRINCIPAL_SUCCESS",
  PRINCIPAL_FAILURE: "principle/PRINCIPAL_FAILURE"
};

const initialState = {
  isLoading: false,
  data: {},
  ids: [],
  error: null
};

export const principals = (state = initialState, action) => {
  switch (action.type) {
    case types.PRINCIPAL_REQUEST:
      return { ...state, isLoading: true };
    case types.PRINCIPAL_SUCCESS:
      return {
        data: action.payload.data,
        ids: action.payload.ids,
        error: null,
        isLoading: false
      };
    case types.PRINCIPAL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export const getPrincipals = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.PRINCIPAL_REQUEST });
    try {
      const response = await getPrincipalsApi();
      const principalList = response.data.Data;
      dispatch({
        type: types.PRINCIPAL_SUCCESS,
        payload: normalize({ data: principalList, key: "PrincipalId" })
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.PRINCIPAL_FAILURE, payload: { error: message } });
    }
  };
};

export const getProfilePrincipals = () => {
  return async (dispatch, getState) => {
    dispatch({ type: types.PRINCIPAL_REQUEST });
    try {
      const params = {
        headers: getAnyTokenFromState(getState())
      };
      const response = await getProfilePrincipalsApi(params);
      const principalList = response.data.Data;
      dispatch({
        type: types.PRINCIPAL_SUCCESS,
        payload: normalize({ data: principalList, key: "PrincipalId" })
      });
    } catch (error) {
      const { message } = getErrorObject(error);
      dispatch({ type: types.PRINCIPAL_FAILURE, payload: { error: message } });
    }
  };
};